import { render } from "./ChatTutorial.vue?vue&type=template&id=32aa0fdd&ts=true"
import script from "./ChatTutorial.ts?vue&type=script&lang=ts&external"
export * from "./ChatTutorial.ts?vue&type=script&lang=ts&external"

import "./ChatTutorial.scss?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__